import $ from "jquery";


class AnimationsController {
  constructor() {
    this.events();
  }

  events() {
    window.addEventListener('DOMContentLoaded', (event) => {

      // SECTION EVENT OF YEAR
      ///////////////////////////////////////////////////////
      // BEACH IMAGE ANIMATION

      if (!!window.IntersectionObserver) {
        let BeachImageAnimation = new IntersectionObserver((entries, BeachImageAnimation) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('beach-image-animation');
              BeachImageAnimation.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: "0px 0px -200px 0px"
        });
        document.querySelectorAll('.animate-beach-image').forEach(box => {
          BeachImageAnimation.observe(box)
        });
        ///////////////////////////////////////////////////////

        // DANCER ONE ANIMATION
        let DancerOneAnimation = new IntersectionObserver((entries, DancerOneAnimation) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('dancer-one-animation');
              DancerOneAnimation.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: "0px 0px -300px 0px"
        });
        document.querySelectorAll('.animate-dancer-one').forEach(box => {
          DancerOneAnimation.observe(box)
        });
        ///////////////////////////////////////////////////////////////

        // SECTION HISTORY
        ///////////////////////////////////////////////////////////////
        // ARENA IMAGE ANIMATION
        let ArenaImageAnimation = new IntersectionObserver((entries, ArenaImageAnimation) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('arena-image-animation');
              ArenaImageAnimation.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: "0px 0px -250px 0px"
        });
        document.querySelectorAll('.animate-arena-image').forEach(box => {
          ArenaImageAnimation.observe(box)
        });
        ///////////////////////////////////////////////////////////////

        // SECTION DISCIPLINES
        ///////////////////////////////////////////////////////////////
        // DANCER TWO ANIMATION
        let DancerTwoAnimation = new IntersectionObserver((entries, DancerTwoAnimation) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('dancer-two-animation');
              DancerTwoAnimation.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: "0px 0px -300px 0px"
        });
        document.querySelectorAll('.animate-dancer-two').forEach(box => {
          DancerTwoAnimation.observe(box)
        });
        ///////////////////////////////////////////////////////////////

        // DANCER THREE ANIMATION
        let DancerThreeAnimation = new IntersectionObserver((entries, DancerThreeAnimation) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('dancer-three-animation');
              DancerThreeAnimation.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: "0px 0px -150px 0px"
        });
        document.querySelectorAll('.animate-dancer-three').forEach(box => {
          DancerThreeAnimation.observe(box)
        });
        ///////////////////////////////////////////////////////////////
      }
    });
  }
}

export default AnimationsController;